<template>
  <div class="netReceiptsAcountBox">
    <div class="netReceiptsAcount">
      <div class="top">
        <div @click="goBack">
          <md-icon name="arrow-left" size="xs" style="font-size: 0.24rem;"></md-icon>
          <span>日实收统计</span>
        </div>
        <div class="time">
          <Calendar v-model="data_picker" @change="changeTime"></Calendar>
        </div>
      </div>
      <div class="total" v-if="list.length>0">
        <span>
          实收金额:
          <span>{{sum_total.real_money_total*1}}</span>
          元，
        </span>
        <span>
          订单实收:
          <span>{{sum_total.payment_total*1}}</span>
          元，
        </span>
        <span>
          还款:
          <span>{{sum_total.annal_total*1}}</span>
          元
        </span>
      </div>
      <div class="listPart" v-if="list.length>0">
        <div class="title">
          <span>收银时间</span>
          <span>实收金额</span>
          <span>订单实收</span>
          <span>还款</span>
          <span>现金</span>
          <span>支付宝</span>
          <span>微信</span>
          <span>银行卡</span>
          <span>其他</span>
          <span>收银员</span>
        </div>
        <div class="listBox">
          <div class="list">
            <md-scroll-view
              ref="scrollView"
              :auto-reflow="true"
              :bouncing="false"
              :scrolling-x="false"
              @end-reached="$_onEndReached"
            >
              <div class="item" v-for="(item,i) in list" :key="i">
                <span>{{item.create_time}}</span>
                <!-- 实收 -->
                <span>{{item.real_money*1}}</span>
                <!-- 订单实收 -->
                <span>{{item.payment*1}}</span>
                <!-- 还款 -->
                <span>{{item.annal*1}}</span>
                <!--现金  -->
                <span>{{item.cash*1}}</span>
                <!-- 支付宝 -->
                <span>{{item.alipay*1}}</span>
                <!-- 微信 -->
                <span>{{item.wechat*1}}</span>
                <!-- 银行卡 -->
                <span>{{item.bank*1}}</span>
                <!-- 其他 -->
                <span>{{item.other*1}}</span>
                <span>{{item.realname}}</span>
              </div>
              <md-scroll-view-more
                :finished-text="list.length>0?'全部已加载':'暂无数据'"
                slot="more"
                :is-finished="isFinished"
              ></md-scroll-view-more>
            </md-scroll-view>
          </div>
        </div>
        <div class="totalAcount">
          <span>合计</span>
          <span>{{total.real_money_sum*1}}</span>
          <span>{{total.payment_sum*1}}</span>
          <span>{{total.annal_sum*1}}</span>
          <!-- 现金 -->
          <span>{{total.cash_sum*1}}</span>
          <!-- 支付宝 -->
          <span>{{total.alipay_sum*1}}</span>
          <!-- 微信 -->
          <span>{{total.wechat_sum*1}}</span>
          <!-- 银行卡 -->
          <span>{{total.bank_sum*1}}</span>
          <!-- 其他 -->
          <span>{{total.other_sum*1}}</span>
          <span></span>
        </div>
      </div>
      <div class="empty" v-if="list.length==0">暂无数据</div>
    </div>
  </div>
</template>
<script>
import { today_acount_real } from "@/api/work/acount/todayAcount";
import { timestampToDate } from "@/utils/timestamp";
import Calendar from "@/components/Calendar";
export default {
  name: "netReceiptsAcount",
  components: {
    Calendar,
  },
  data() {
    return {
      dataQuery: {
        s: "",
        e: "",
        orderby: "",
        desc: "",
        page: 1,
        pagesize: 55,
      },
      data_picker: [],
      total: {
        order_amount_sum:'',
        real_money_sum:'',
        payment_sum:'',
        annal_sum:'',
        cash_sum:'',
        alipay_sum:'',
        wechat_sum:'',
        bank_sum:'',
        count:'',
        pos_sum:'',
        unionpay_sum:'',
        other_sum:''
      }, //总计
      sum_total: {
        order_amount_total:'',//总订单金额
        real_money_total:'',//总实收金额
        annal_total:'',//总历史还款
        count:'',
        payment_total:''//订单实收
      }, //总
      list: [],
      isFinished: false,
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    //获取列表数据
    getList() {
      if (this.dataQuery.page == 1) {
        this.list = [];
      }
      today_acount_real(this.dataQuery).then((res) => {
        if (res.code == 200) {
          //总计
          this.sum_total.order_amount_total = res.data.list.sum_total.order_amount_total || 0;
          this.sum_total.real_money_total = res.data.list.sum_total.real_money_total || 0;
          this.sum_total.annal_total = res.data.list.sum_total.annal_total || 0;
          this.sum_total.count = res.data.list.sum_total.order_amoucountnt_total || 0;
          this.sum_total.payment_total = res.data.list.sum_total.payment_total || 0;
          //合计
          this.total.order_amount_sum = res.data.list.total.order_amount_sum || 0;
          this.total.real_money_sum = res.data.list.total.real_money_sum || 0;
          this.total.payment_sum = res.data.list.total.payment_sum || 0;
          this.total.annal_sum = res.data.list.total.annal_sum || 0;
          this.total.cash_sum = res.data.list.total.cash_sum || 0;
          this.total.alipay_sum = res.data.list.total.alipay_sum || 0;
          this.total.wechat_sum = res.data.list.total.wechat_sum || 0;
          this.total.bank_sum = res.data.list.total.bank_sum || 0;
          this.total.count = res.data.list.total.count || 0;
          this.total.pos_sum = res.data.list.total.pos_sum || 0;
          this.total.unionpay_sum = res.data.list.total.unionpay_sum || 0;
          this.total.other_sum = res.data.list.total.other_sum || 0;
          
          this.total = res.data.list.total;
          this.list = this.list.concat(res.data.list.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.dataQuery.page++;
          }
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    //选择时间
    changeTime(e) {
      if (this.data_picker) {
        this.dataQuery.s = timestampToDate(this.data_picker[0]);
        this.dataQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.dataQuery.s = "";
        this.dataQuery.e = "";
      }
      this.dataQuery.page = 1;
      this.list = [];
      this.getList();
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.netReceiptsAcountBox {
  height: 100%;
  padding: 0.1rem;
  padding-bottom: 0;
  .netReceiptsAcount {
    padding: 0.2rem;
    background: #fff;
    border-radius: 0.1rem;
    padding-bottom: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    height: 100%;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 0.1rem;
      height: 0.45rem;
      > div:nth-of-type(1) {
        color: #31b158;
        margin-bottom: 0.14rem;
        font-size: 0.24rem;
        font-weight: bold;
      }
    }
    .total {
      display: flex;
      align-items: center;
      font-size: 0.22rem;
      color: #404040;
      margin: 0 0.22rem;
      margin-bottom: 0.2rem;

      height: 0.3rem;
      > span {
        span {
          color: #31b158;
        }
      }
    }
    .listPart {
      height: calc(100% - 0.45rem - 0.3rem - 0.2rem);
      margin: 0 0.22rem;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 0.68rem;
        border-top: 0.01rem solid #e5e5e5;
        > span {
          text-align: center;
          color: #555;
          font-weight: bold;
        }
        > span:nth-of-type(1) {
          width: 1rem;
        }
        > span:nth-of-type(2) {
          width: 1.6rem;
        }
        > span:nth-of-type(3) {
          width: 1.4rem;
        }
        > span:nth-of-type(4) {
          width: 1.2rem;
        }
        > span:nth-of-type(5) {
          width: 1.2rem;
        }
        > span:nth-of-type(6) {
          width: 1rem;
        }
        > span:nth-of-type(7) {
          width: 1.2rem;
        }
        > span:nth-of-type(8) {
          width: 1rem;
        }
        > span:nth-of-type(9) {
          width: 1rem;
        }
        > span:nth-of-type(10) {
          width: 0.8rem;
        }
      }
      .listBox {
        height: calc(100% - 0.68rem - 0.68rem);
        .list {
          height: 100%;
          font-size: 0.18rem;
          .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 0.8rem;
            border-top: 0.01rem solid #e5e5e5;
            > span {
              text-align: center;
            }
            > span:nth-of-type(1) {
              width: 1rem;
            }
            > span:nth-of-type(2) {
              width: 1.6rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            > span:nth-of-type(3) {
              width: 1.4rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            > span:nth-of-type(4) {
              width: 1.2rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            > span:nth-of-type(5) {
              width: 1.2rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            > span:nth-of-type(6) {
              width: 1rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            > span:nth-of-type(7) {
              width: 1.2rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            > span:nth-of-type(8) {
              width: 1rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            > span:nth-of-type(9) {
              width: 1rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            > span:nth-of-type(10) {
              width: 0.8rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
      }

      .totalAcount {
        height: 0.68rem;
        border-bottom: 0.01rem solid #e5e5e5;
        border-top: 0.01rem solid #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > span {
          color: #404040;
          font-weight: bold;
          font-size: 0.22rem;
          text-align: center;
        }
        > span:nth-of-type(1) {
          width: 1rem;
        }
        > span:nth-of-type(2) {
          width: 1.6rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(3) {
          width: 1.4rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(4) {
          width: 1.2rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(5) {
          width: 1.2rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(6) {
          width: 1rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(7) {
          width: 1.2rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(8) {
          width: 1rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(9) {
          width: 1rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(10) {
          width: 0.8rem;
        }
      }
    }
    .empty {
      text-align: center;
      height: calc(100% - 0.45rem - 0.4rem - 0.36rem - 0.36rem - 0.36rem);
      color: #999;
    }
  }
}
</style>
<style lang="less">
.time {
  .calendar_select_box {
    width:2.6rem!important;
    border: 0.01rem solid #e5e5e5!important;
    background: #fff !important;
  }
}
</style>
    
